
export default {
  name: 'FaqComponent',
  props: {
    title: { type: Array, default: () => [] },
    faqs: { type: Array, default: () => [] },
    darkBg: {
      type: Boolean,
      default: false,
    },
  },
}
